import { z } from "zod";

// form zod validation schema
export const createLocationSchema = z.object({
  name: z.string().min(1, "This field is required"),
});

// generate form types from zod validation schema
export type CreateLocationInput = z.infer<typeof createLocationSchema>;
